import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      backgroundColor: '#9A63F2',
      borderRadius: 12,
      display: 'block',
      color: '#fff',
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '24px',
      marginBlockStart: 16,
      padding: [6, 8],
    },
    container: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    },
    text02: {
      textDecoration: 'underline',
      marginInlineStart: 6,
    },
    icon: {
      fill: '#fff',
      height: 20,
      marginLeft: 12,
      width: 20,
    },
  },
  { name: 'GenerateTextBanner' },
);
